<template>
  <div>
    <!-- 顶部面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 总收益 -->
    <div>
      <!-- 表格 -->
      <el-table stripe :data="tableData" border style="width: 100%">
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="100"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="day" label="时间"> </el-table-column>
        <el-table-column prop="orderNum" label="分润订单数（笔）">
        </el-table-column
        ><el-table-column prop="orderPrice" label="分润订单金额（元）">
        </el-table-column>
        <el-table-column prop="sharePrice" label="分润收益"> </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout=" prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      tableData: [], //收益详情数据
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 5, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      month: "",
    };
  },
  created() {
    this.month = this.$route.query.month;
    this.getdayBill();
  },
  methods: {
    getdayBill() {
      this.$api.enterpriseincome
        .dayBill({
          month: this.month,
          pageNum: this.page,
          pageSize: this.pageSize,
        })
        .then((res) => {
          console.log(res, "日账单");
          if (res.code === 200) {
            this.tableData = res.data.rows;
            this.total = res.data.total;
          }
        });
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      this.getdayBill();
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      console.log(val);
      this.page = val;
      this.getdayBill();
    },
  },
};
</script>

<style lang="scss" scoped>
// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}
</style>
